import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { TourStatiServiceModule } from '..';
import { TourStatiListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    TourStatiServiceModule
  ],
  declarations: [TourStatiListComponent],
  exports: [TourStatiListComponent],

})
export class TourStatiListComponentModule { }
